import getImageProcessData from "@/components/Dashboard/components/AccountDetails/ImageProccessData/handlers/getImageProcessData";
import { USER_PROFILE_KEY } from "@/components/Root/hooks/useUserProfile";
import { useQuery, useQueryClient } from "@tanstack/react-query";

export const IMAGE_PROCESS_DATA_QUERY_KEY = "image-process-data";

export function useImageProcessDataQuery() {
  const client = useQueryClient();
  const userData = client.getQueryData([USER_PROFILE_KEY]) as any;
  const referralCode = userData?.data?.referral?.code;

  return useQuery({
    queryKey: [IMAGE_PROCESS_DATA_QUERY_KEY, referralCode ?? ""],
    queryFn: () => getImageProcessData(referralCode ?? ""),
    enabled: !!referralCode,
  });
}
